<!--
 * @Author: mzw
 * @Date: 2021-09-18 14:35:27
 * @LastEditors: mzw
 * @LastEditTime: 2021-10-21 10:00:51
 * @Description: 地址列表组件
-->
<template>
  <div>
        <div class="address-box" v-if="dataLists.length>0">
            <ul>
                <li v-for="(item, index) in dataLists"
                    :key="index" :class="[item.userAddressId==checkedAddressId ? 'checked-li':'' ]"
                    @click="addressChangeHandle(item)"
                    @mouseenter="enters(item.userAddressId)"
                    @mouseleave="leaver">
                    <div class="ad-brief">{{item.receiveGoodsPerson}} {{item.city}}</div>
                    <div class="ad-spec">
                    <i class="el-icon-location-outline"></i>
                    {{item.receiveGoodsPerson}} {{item.receiveGoodsPhone}} {{item.province}} {{item.city}} {{item.area}} {{item.address}}
                    <span v-if="item.defaultAddress" class="flag">{{$t('order.defaultAddress')}}</span>
                    </div>
                    <div class="ad-btnBox" v-show="hoverId==item.userAddressId" v-if="!isAsOther">
                        <!-- <span v-if="!item.defaultAddress">设为默认地址</span> -->
                        <span @click.stop="addressEditHandle(item)">{{$t('order.updateAddress')}}</span>
                        <span @click.stop="addressDeleteHandle(item)">{{$t('order.delAddress')}}</span>
                    </div>
                </li>
            </ul>
            <span @click="toggleAddress(showAddressVisible)" v-if="!isAsOther">
                <template v-if="showAddressVisible">
                    {{$t('order.collapseAddress')}}<i class="el-icon-arrow-up"></i>
                </template>
                <template v-if="!showAddressVisible">
                    {{$t('order.openAddress')}}<i class="el-icon-arrow-down"></i>
                </template>
            </span>
        </div>
        <div class="address-box" v-else>
            <div class="no-data">{{$t('order.emptyAddress')}}</div>
        </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      hoverId: '', // 鼠标移入id
      dataLists: []
    }
  },
  props: {
    addressList: {
      type: Array,
      default: () => {
        return []
      }
    },
    showAddressVisible: {
      type: Boolean,
      default: true
    },
    checkedAddressId: { // 选中项id
      type: String,
      default: ''
    },
    isAsOther: { // 同其他列表，只显示选中的那条且不可编辑
      type: Boolean,
      default: false
    }
  },
  watch: {
    addressList: {
      handler (newVal) { // 只能写handler才能生效
        this.dataLists = newVal // 设置初始dataLists值
      },
      immediate: true
    },
    showAddressVisible (val) {
      let oldLists = this.addressList
      let checkedId = this.checkedAddressId
      if (!val) { // 收起地址 仅展示一条：有选中则展示选中条，无则展示第一条
        if (!checkedId) {
          this.dataLists = [].concat(oldLists[0])
        } else {
          let dataLists = oldLists.filter(item => {
            return item.userAddressId == checkedId
          })
          this.dataLists = dataLists
        }
      } else { // 展开地址 展示所有地址列表
        this.dataLists = oldLists
      }
    }
  },
  methods: {
    addressChangeHandle (item) {
      this.$emit('addressChangeHandle', item)
    },
    addressEditHandle (item) {
      this.$emit('addressEditHandle', item)
    },
    addressDeleteHandle (item) {
      this.$emit('addressDeleteHandle', item)
    },
    toggleAddress (flag) {
      this.$emit('toggleAddress', flag)
    },
    enters (id) {
      this.hoverId = id
    },
    leaver () {
      this.hoverId = ''
    }
  }
}
</script>
<style lang='scss' scoped>
    .address-box {
        width: 100%;
        height: auto;
        background: #F9F9F9;
        box-sizing: border-box;
        border: 1px solid #ddd;
        padding: 24px;
        &>ul {
            width: 100%;
            max-height: 240px;
            overflow-y: auto;
            li {
                width: 100%;
                height: 36px;
                margin-bottom: 24px;
                padding-right: 8px;
                box-sizing: border-box;
                &:hover {
                    background-color: #F2F2F2;
                }
                .ad-brief {
                    width: 130px;
                    padding: 0 6px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    box-sizing: border-box;
                    border: 1px solid #ddd;
                    background-color: #fff;
                    float: left;
                    margin-right: 28px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .ad-spec {
                    float: left;
                    height: 36px;
                    line-height: 36px;
                    font-size: 14px;
                    color: #333;
                    max-width: 730px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    .flag {
                        display: inline-block;
                        padding: 0 3px;
                        height: 17px;
                        line-height: 17px;
                        background: #3D88D4;
                        color: #fff;
                        font-size: 12px;
                        margin-left: 12px;
                    }
                }
                .ad-btnBox {
                    float: right;
                    font-size: 14px;
                    height: 36px;
                    line-height: 36px;
                    &>span {
                        margin-left: 24px;
                        color: #3D88D4;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
                &.checked-li {
                    .ad-brief {
                        border: 1px solid #3D88D4;
                        position: relative;
                        &:after {
                            content: "";
                            display: block;
                            height: 47px;
                            width: 47px;
                            background-image: url('../../../../assets/img/order/checkIcon.png');
                            background-size: 100%;
                            position: absolute;
                            right: -21px;
                            bottom: -20px;
                        }
                    }
                    background-color: #F2F2F2;
                }
            }
        }
        &>span {
            color: #797979;
            font-size: 14px;
            cursor: pointer;
        }
        .no-data{
            height: 36px;
            line-height: 36px;
            background: #F2F2F2;
            color: #909399;
            text-align: center;
        }
    }
</style>
